import React, { createContext, useContext, useState } from 'react';
import Dialog, { IDialogProps, IDialogPropsWithId } from './Dialog';

interface IDialogContext {
    openDialog: (dialog: IDialogProps) => number
    closeDialog: (id?: number) => void
}

interface IDialogProviderProps {
    children: any
}

const DialogContext = createContext<IDialogContext>({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    openDialog: (dialog: IDialogProps) => { return 0 },
    closeDialog: (id?: number) => { }
});

export const useDialog = () => {
    return useContext(DialogContext);
}

let cnt = 1;

function DialogProvider({ children }: IDialogProviderProps) {
    const [dialogs, setDialogs] = useState<Array<IDialogPropsWithId>>([]);

    const openDialog = (dialog: IDialogProps) => {
        setDialogs([
            ...dialogs,
            {
                ...dialog,
                id: cnt,
                onClose: (id) => {
                    dialog.onClose && dialog.onClose(id);
                    closeDialog(id);
                }
            }
        ]);
        return cnt++;
    }

    const closeDialog = (id = dialogs[0].id) => {
        setDialogs(dialogs.filter(item => item.id !== id));
    }

    return (
        <>
            <DialogContext.Provider value={{ openDialog, closeDialog }}>
                {children}
                {
                    !!dialogs.length &&
                    <Dialog {...dialogs[0]} />
                }
            </DialogContext.Provider>
        </>
    );
}

export default DialogProvider;
